/* eslint-disable no-console */
const lsObjName = 'swfBlogClick';

const setBlogPageClick = () => {
  window.localStorage.setItem(lsObjName, true);
};

const checkBlogPageClick = () => (
  window.localStorage.getItem(lsObjName)
);

const goBackToPreviousPage = (fallbackPage) => {
  if (window.localStorage.getItem(lsObjName)) {
    window.localStorage.removeItem(lsObjName);
    window.history.back();
  } else {
    window.location = fallbackPage;
  }
};

export {
  setBlogPageClick,
  checkBlogPageClick,
  goBackToPreviousPage,
};
/* eslint-enable no-console */
